import { Config } from 'ha/config';
import FetchClient from 'ha/helpers/FetchClient';
import { Language } from '@ha/intl';

import createTranslationService from './Translation';
import makeFBService from './facebook';
import googleMapApi from './GoogleMapApi';
import createApiV2 from './apiV2';
import makeAnalyticsService from './analytics';
import algoliaService from './algolia';
import makeStripeService from './Stripe';
import makeTwilioService from './twilio';
import makeMonetaService from './moneta';
import makeOsirisService from './osiris';
import makeTiktokService from './tiktok';
import makeHermesService from './hermes';
import makeAlmanacService from './almanac';
import makeMetisService from './metis';
import makeBellService from './bell';
import makeCookieService, { CookieClient } from './cookie';
import LocalyseService from './localyse';

import SplitIO from './SplitIO';

interface Clients {
  haApi: FetchClient;
  moneta: FetchClient;
  osiris: FetchClient;
  hermes: FetchClient;
  almanac: FetchClient;
  metis: FetchClient;
  bell: FetchClient;
  splitio: SplitIO;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  algolia: ReturnType<typeof algoliaService>;
  localyse: LocalyseService;
  cookie: CookieClient;
}
interface AppServicesSetup {
  config: Config;
  clients: Clients;
  lang: Language;
}

function getAppServices({ config, clients, lang }: AppServicesSetup) {
  return {
    translation: createTranslationService(
      {
        languageDetectionURL: config.languageDetectionURL,
      },
      clients.haApi,
    ),
    algolia: clients.algolia,
    facebook: makeFBService({
      clientId: config.facebook.client_id,
      clientToken: config.facebookClientToken,
    }),
    googleMapApi: googleMapApi({ key: config.google.maps_key, language: lang }),
    apiV2: createApiV2(clients.haApi),
    hermes: makeHermesService(clients.hermes),
    almanac: makeAlmanacService(clients.almanac),
    metis: makeMetisService(clients.metis),
    moneta: makeMonetaService(clients.moneta),
    osiris: makeOsirisService(clients.osiris),
    bell: makeBellService(clients.bell),
    cookie: makeCookieService(clients.cookie),
    analytics: makeAnalyticsService(config),
    stripe: makeStripeService(config),
    tiktok: makeTiktokService(),
    twilio: makeTwilioService(),
    splitio: clients.splitio,
    localyse: clients.localyse,
  };
}

export type AppServices = ReturnType<typeof getAppServices>;

export default getAppServices;
